// src/utils/pushRegistration.ts
import BaseService from "../service/base.service";

const VAPID_PUBLIC_KEY =
    "BCWoprK6XqN4k2Ipr1jJOhLl1_RPs85PdMZyfbRr-t1J_2um3z-mERoo4gUxy9sTMBboxfrsKw3FCuA-UW-Bdvc";

export async function registerPushNotifications() {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
        return;
    }

    try {
        // Ensure SW is registered
        const registration =
            (await navigator.serviceWorker.getRegistration()) ||
            (await navigator.serviceWorker.register("/serviceWorker.js"));

        // Ask permission
        const permission = await Notification.requestPermission();
        if (permission !== "granted") {
            return;
        }

        // Check existing subscription
        let subscription = await registration.pushManager.getSubscription();

        if (!subscription) {
            subscription = await registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
            });
        }

        // Always send subscription to backend
        await BaseService.subscribeUserToPush(subscription);
    } catch (error) {
        console.error("[Push] Error during registration:", error);
    }
}

function urlBase64ToUint8Array(base64String: string) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}
